import { Modal } from "ant-design-vue";

export const errorInfoDis = async (msg: string) => {
  Modal.destroyAll();
  Modal.error({
    title: "错误信息提示",
    content: `${msg}`,
  });
};
